import LockupSales from './lockupSales'

export default LockupSales
